import React from 'react';
import { formatNormalizedScorePercent } from 'js/utils/format';
import {
  makeRollupWeightFn,
  rollupWeightedMedian,
  rollupWeightedScores,
} from 'js/utils/question-set';
import { map, mean } from 'lodash';
import classNames from 'classnames';
import Variability from './Variability';

const QuestionSetSubview = ({ questionSet }) => {
  const variances = map(questionSet.questions, (q) =>
    q.normalizedScore === null
      ? null
      : Math.pow(questionSet.normalizedScore - q.normalizedScore, 2)
  ).filter((x) => x !== null);
  const normalizedVariance = variances.length === 0 ? null : mean(variances);
  const normalizedDev =
    normalizedVariance === null ? null : Math.sqrt(normalizedVariance);
  const questionList = Object.values(questionSet.questions ?? {});
  const getQuestionWeight = makeRollupWeightFn(questionList);
  const meanScore = rollupWeightedScores(questionList, {
    getScore: (q) => q.normalizedScore,
    getWeight: getQuestionWeight,
  });
  const medianScore = rollupWeightedMedian(questionList, {
    getScore: (q) => q.normalizedScore,
    getWeight: getQuestionWeight,
  });

  return (
    <>
      <section className="figure-stats">
        <label>Question Set</label>
        <h3 className="view-name">{questionSet.displayName}</h3>
        <table style={{ width: '100%' }}>
          <tbody>
            <tr>
              <td>
                <label>Mean Score</label>
                <h5
                  className={classNames({ 'text-muted': meanScore === null })}
                >
                  {meanScore === null
                    ? 'N/A'
                    : formatNormalizedScorePercent(meanScore)}
                </h5>
              </td>
              <td>
                <label>Median Score</label>
                <h5
                  className={classNames({ 'text-muted': medianScore === null })}
                >
                  {medianScore === null
                    ? 'N/A'
                    : formatNormalizedScorePercent(medianScore)}
                </h5>
              </td>
            </tr>
            <tr>
              <td>
                <label>Variability</label>
                <Variability varianceScore={normalizedDev} />
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </section>
      <section className="figure-spacer"></section>
      <section className="figure-detail" />
    </>
  );
};

export default QuestionSetSubview;
